import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

interface IAuthState {
  isAuthorized: boolean;
}

const initialState: IAuthState = {
  isAuthorized: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsAuthorized: (state, action: PayloadAction<boolean>) => {
      state.isAuthorized = action.payload;
    }
  }
});

export const { setIsAuthorized } = authSlice.actions;
export default authSlice;
